import * as types from "./mutation-types";
import { backendAddress } from "@/utils/helpers";

export default {
  [types.LOADING](state) {
    state.loading = true;
  },
  [types.LOADED](state) {
    state.loading = false;
  },
  [types.LOGIN](state) {
    state.isLoggedIn = true;
  },
  [types.LOGOUT](state) {
    state.isLoggedIn = false;
  },
  [types.SETLAYOUT](state, config) {
    state.layoutConfig = config;
    backendAddress().then(url => {
      state.layoutConfig.logo = url + "/" + state.layoutConfig.logo;
    });
  },
  [types.SETKEY](state) {
    state.key = Math.floor(Math.random() * 100 + 1);
  }
};
